// extracted by mini-css-extract-plugin
module.exports = {"card":"ComboCard_card__2srqX","left":"ComboCard_left__1acon","info":"ComboCard_info__fbVx-","image":"ComboCard_image__9ZVxq","code":"ComboCard_code__1xQ6D"};